var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('blog-side-bar', {
    staticClass: "blog-side-bar"
  }, [_c('div', {
    staticClass: "blog-side-right"
  }, [_c('h3', {
    staticClass: "categories"
  }, [_vm._v("CATEGORIES")]), _vm._v(" "), _c('blog-unordered', {
    staticClass: "blog-unordered"
  }, [_c('li', {
    staticClass: "blog-ipsum"
  }, [_c('i', {
    staticClass: "fa li fa-arrow-circle-right"
  }), _vm._v("LOGO DESIGN")]), _vm._v(" "), _c('li', {
    staticClass: "blog-ipsum"
  }, [_c('i', {
    staticClass: "fa li fa-arrow-circle-right"
  }), _vm._v("WEB DESIGN")]), _vm._v(" "), _c('li', {
    staticClass: "blog-ipsum"
  }, [_c('i', {
    staticClass: "fa li fa-arrow-circle-right"
  }), _vm._v("PHOTOGRAPHY")]), _vm._v(" "), _c('li', {
    staticClass: "blog-ipsum"
  }, [_c('i', {
    staticClass: "fa li fa-arrow-circle-right"
  }), _vm._v("WORDPRESS")]), _vm._v(" "), _c('li', {
    staticClass: "blog-ipsum"
  }, [_c('i', {
    staticClass: "fa li fa-arrow-circle-right"
  }), _vm._v("ICONS")])]), _vm._v(" "), _c('h3', {
    staticClass: "recent-post"
  }, [_vm._v("RECENT POSTS")]), _vm._v(" "), _c('recent-post-arrow', {
    staticClass: "recent-post-arrow"
  }, [_c('li', {
    staticClass: "post-arrow"
  }, [_c('i', {
    staticClass: "fa li fa-angle-right"
  }), _vm._v("Curabitur vitae velit")]), _vm._v(" "), _c('li', {
    staticClass: "digits"
  }, [_vm._v("25 May 2013")]), _vm._v(" "), _c('li', {
    staticClass: "post-arrow"
  }, [_c('i', {
    staticClass: "fa li fa-angle-right"
  }), _vm._v("Vivamus at elit quis urna")]), _vm._v(" "), _c('li', {
    staticClass: "text"
  }, [_vm._v("adipiscing iaculis")]), _vm._v(" "), _c('li', {
    staticClass: "digits"
  }, [_vm._v("25 May 2013")]), _vm._v(" "), _c('li', {
    staticClass: "post-arrow"
  }, [_c('i', {
    staticClass: "fa li fa-angle-right"
  }), _vm._v("Curabitur vitae velit")]), _vm._v(" "), _c('li', {
    staticClass: "digits"
  }, [_vm._v("25 May 2013")]), _vm._v(" "), _c('li', {
    staticClass: "post-arrow"
  }, [_c('i', {
    staticClass: "fa li fa-angle-right"
  }), _vm._v("Vivamus at elit quis urna")]), _vm._v(" "), _c('li', {
    staticClass: "text"
  }, [_vm._v("adipiscing iaculis")]), _vm._v(" "), _c('li', {
    staticClass: "digits"
  }, [_vm._v("25 May 2013")])]), _vm._v(" "), _c('h3', {
    staticClass: "tags"
  }, [_vm._v("TAGS")]), _vm._v(" "), _c('nav', {
    staticClass: "tags-work"
  }, [_c('ul', {
    staticClass: "tags-rigth"
  }, [_c('li', {
    staticClass: "necessary"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Maecenas")])]), _vm._v(" "), _c('li', {
    staticClass: "necessary"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nunc")])]), _vm._v(" "), _c('li', {
    staticClass: "necessary"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Praesent")])]), _vm._v(" "), _c('li', {
    staticClass: "necessary"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nunc")])]), _vm._v(" "), _c('li', {
    staticClass: "necessary"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Praesent")])]), _vm._v(" "), _c('li', {
    staticClass: "necessary"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nunc")])]), _vm._v(" "), _c('li', {
    staticClass: "necessary"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Maecenas")])]), _vm._v(" "), _c('li', {
    staticClass: "necessary"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Praesent")])]), _vm._v(" "), _c('li', {
    staticClass: "necessary"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nunc")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "archive"
  }, [_vm._v("ARCHIVE")]), _vm._v(" "), _c('archive-unordered', {
    staticClass: "archive-unordered"
  }, [_c('li', {
    staticClass: "archive-digits"
  }, [_c('i', {
    staticClass: "fa li fa-arrow-circle-right"
  }), _vm._v("2013")]), _vm._v(" "), _c('li', {
    staticClass: "archive-digits"
  }, [_c('i', {
    staticClass: "fa li fa-arrow-circle-right"
  }), _vm._v("2012")]), _vm._v(" "), _c('li', {
    staticClass: "archive-digits"
  }, [_c('i', {
    staticClass: "fa li fa-arrow-circle-right"
  }), _vm._v("2011")])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c6de7a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/blog-side-bar/blog-side-bar.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-26c6de7a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/blog-side-bar/blog-side-bar.vue
// module chunks = index